export const GET_DEPARTMENTS = 'GET_DEPARTMENTS';
export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT';
